import { render } from "./Login.vue?vue&type=template&id=a2ac2cea"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "a2ac2cea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a2ac2cea', script)) {
    api.reload('a2ac2cea', script)
  }
  
  module.hot.accept("./Login.vue?vue&type=template&id=a2ac2cea", () => {
    api.rerender('a2ac2cea', render)
  })

}

script.__file = "resources/js/Pages/Auth/Login.vue"

export default script